import { createSlice } from '@reduxjs/toolkit';

// All navigation + view state for the shell (tabs, date range, geo drill-down).
const initialState = {
  tab: 'overall',        // 'overall' | channelId | 'users' | 'influencers' | 'options'
  channelTab: 'dashboard', // 'dashboard' | 'leads' | 'accounts' | 'ledger'
  overallTab: 'overview',  // 'overview' | 'geo'
  leadView: 'list',        // 'list' | 'board'
  range: 30,
  sidebarOpen: false,
  influencerChannel: 'd2c',
  geo: {
    mode: 'cond',          // 'cond' | 'test'
    // null means 'whatever the API considers first' — the vocabulary lives server-side now
    key: null,
    district: null,
    mandal: null,
    gender: 'all',
    age: 'all',
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setTab: (s, a) => {
      s.tab = a.payload;
      s.channelTab = 'dashboard';
      s.sidebarOpen = false;
    },
    setChannelTab: (s, a) => { s.channelTab = a.payload; },
    setOverallTab: (s, a) => { s.overallTab = a.payload; },
    setLeadView: (s, a) => { s.leadView = a.payload; },
    setRange: (s, a) => { s.range = Number(a.payload); },
    toggleSidebar: (s) => { s.sidebarOpen = !s.sidebarOpen; },
    closeSidebar: (s) => { s.sidebarOpen = false; },
    setInfluencerChannel: (s, a) => { s.influencerChannel = a.payload; },
    setGeoMode: (s, a) => {
      if (s.geo.mode === a.payload) return;
      s.geo.mode = a.payload;
      s.geo.key = null; // let the new mode's first key apply
    },
    setGeoKey: (s, a) => { s.geo.key = a.payload; },
    setGeoGender: (s, a) => { s.geo.gender = a.payload; },
    setGeoAge: (s, a) => { s.geo.age = a.payload; },
    drillDistrict: (s, a) => { s.geo.district = a.payload; s.geo.mandal = null; },
    drillMandal: (s, a) => { s.geo.mandal = s.geo.mandal === a.payload ? null : a.payload; },
    geoBack: (s) => { s.geo.district = null; s.geo.mandal = null; },
  },
});

export const {
  setTab, setChannelTab, setOverallTab, setLeadView, setRange,
  toggleSidebar, closeSidebar, setInfluencerChannel,
  setGeoMode, setGeoKey, setGeoGender, setGeoAge, drillDistrict, drillMandal, geoBack,
} = uiSlice.actions;

export default uiSlice.reducer;
